export default {
      id: "ic-notifications-usage",
      viewBox: "0 0 30 30",
      url: "../dist/images/" + "sprite.svg#ic-notifications-usage",
      toString: function () {
        return this.url;
      }
    }